// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","631":"contact","824":"portfolio"}[chunkId] + "." + {"443":"e25a1faf","631":"a5f63aec","824":"e9bd17f6"}[chunkId] + ".js";
};